import script from "./recipe-selector-dashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./recipe-selector-dashboard.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__